import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { Alert } from '../../../components/Alert';
import { PageSpinner } from '../../../components/PageSpinner';
import { adminApi } from '../../../features/admin/admin.api';
import { toDisplayMessage } from '../../../lib/error-message';
import { routeTo } from '../../../routes/paths';
import styles from './AdminPortal.module.css';

export function AdminRolesPage(): React.JSX.Element {
  const roles = useQuery({ queryKey: ['admin', 'roles'], queryFn: () => adminApi.listRoles() });

  return (
    <div className={styles.page}>
      <header className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Roles</h1>
        <p className={styles.pageSubtitle}>
          System roles are seeded from the catalogue and cannot be deactivated.
        </p>
      </header>

      <section className={styles.card} aria-labelledby="roles-heading">
        <h2 className={styles.cardTitle} id="roles-heading">
          Defined roles
        </h2>

        {roles.isPending && <PageSpinner label="Loading roles" />}
        {roles.isError && <Alert tone="error">{toDisplayMessage(roles.error)}</Alert>}

        {roles.isSuccess && (
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <caption>{roles.data.pagination.totalItems} roles</caption>
              <thead>
                <tr>
                  <th scope="col">Code</th>
                  <th scope="col">Name</th>
                  <th scope="col">Permissions</th>
                  <th scope="col">Assigned to</th>
                  <th scope="col">Protected</th>
                </tr>
              </thead>
              <tbody>
                {roles.data.items.map((role) => (
                  <tr key={role.id}>
                    <td>
                      <Link to={routeTo.adminRole(role.id)}>
                        <code>{role.code}</code>
                      </Link>
                    </td>
                    <td>{role.name}</td>
                    <td>{role.permissionCodes.length}</td>
                    <td>{role.assignedUserCount}</td>
                    <td>{role.isSystem ? 'System role' : 'Custom'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
